import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { Skeleton } from '@material-ui/lab';
import { useState } from 'react';
import { ImageFallback } from 'utils';
import styles from './styles.module.css';

const PaymentMethodsTab = ({
  openTab = true,
  setOpenTab = () => {},
  translateCheckout = () => {},
  paymentMethods = [],
  selectedVal = '',
  handleChange = () => {},
  locale = 'en',
}) => {
  const [paymentMethodSelected, setPaymentMethodSelected] = useState(selectedVal);

  const handleChangePaymentMethodOption = (e) => {
    setPaymentMethodSelected(e.target.value);
  };
  const handleClose = () => {
    setOpenTab(false);
  };

  const handleSubmitPaymentMethod = () => {
    const e = { target: { value: paymentMethodSelected } };
    handleChange(e);
    setOpenTab(false);
  };

  return (
    <Modal
      open={openTab}
      handleClose={handleClose}
      fullScreen
      fullWidth
      style={{
        backgroundColor: '#fff',
        position: 'fixed',
        zIndex: '1300',
        inset: '0px',
      }}
    >
      <Grid container direction="column" className={styles.containerModal}>
        <Grid item onClick={handleClose} className={styles.headerBack}>
          <Button className={styles.iconBackButton}>
            <ArrowBackIos style={{ width: '16px', height: '16px' }} />
            <span className={styles.titleBackButton}>{translateCheckout('payment_method')}</span>
          </Button>
        </Grid>
        <Grid item className={styles.listItemsBox}>
          <Grid container direction="column" style={{ height: '100%', flexWrap: 'unset' }}>
            <div className={styles.listItems}>
              <FormControl
                component="fieldset"
                style={{ width: '100%', height: '85%', marginTop: 8 }}
              >
                <FormGroup className={styles.radioGroup}>
                  {paymentMethods?.length > 0 ? (
                    paymentMethods.map((item) => {
                      const paymentMethodName = item[`name_${locale}`] || item?.name || '';
                      const paymentMethodSubTitle =
                        item[`subTitle_${locale}`] || item?.subTitle || '';
                      return (
                        <RadioGroup
                          key={item.code}
                          value={paymentMethodSelected}
                          className={styles.groupCheckBox}
                          onChange={handleChangePaymentMethodOption}
                        >
                          <FormControlLabel
                            value={item.code}
                            disabled={item.isDisable}
                            control={<Radio size="small" />}
                            label={
                              <Box display="flex" gridGap={8} alignItems="center">
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  justifyContent="center"
                                  flexGrow={1}
                                  gridGap={4}
                                >
                                  <h6 className={styles.titleContent}>{paymentMethodName}</h6>
                                  {paymentMethodSubTitle.length > 0 && (
                                    <div className={styles.subTitle}>
                                      {item?.url?.length > 0 ? (
                                        <a href={item.url} target="_blank" rel="noreferrer">
                                          {paymentMethodSubTitle}
                                        </a>
                                      ) : (
                                        paymentMethodSubTitle
                                      )}
                                    </div>
                                  )}
                                </Box>
                                <Box display="flex" flexWrap="no-wrap" gridGap={4}>
                                  {item?.svgIcons?.length > 0 &&
                                    item.svgIcons.map((svgIconURL) => (
                                      <ImageFallback
                                        key={svgIconURL}
                                        src={svgIconURL}
                                        alt={item.name}
                                        width="40px"
                                        height="36px"
                                      />
                                    ))}
                                </Box>
                              </Box>
                            }
                          />
                        </RadioGroup>
                      );
                    })
                  ) : (
                    <>
                      <Skeleton variant="rect" width="100%" height={70} />
                      <Skeleton variant="rect" width="100%" height={70} />
                      <Skeleton variant="rect" width="100%" height={70} />
                      <Skeleton variant="rect" width="100%" height={70} />
                      <Skeleton variant="rect" width="100%" height={70} />
                      <Skeleton variant="rect" width="100%" height={70} />
                    </>
                  )}
                </FormGroup>
              </FormControl>
            </div>
            <div className={styles.listItems}>
              <div className={styles.donePaymentButtonBox}>
                <Button
                  variant="contained"
                  color="primary"
                  className={styles.donePaymentButton}
                  onClick={handleSubmitPaymentMethod}
                >
                  {translateCheckout('confirm')}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

const PaymentMethodMobile = ({
  translateCheckout = () => {},
  paymentMethods = [],
  selectedVal = '',
  handleChange = () => {},
  locale = 'en',
  selectedPaymentName = '',
  selectedPaymentSubTitle = '',
  selectedPaymentMethod = {},
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Grid container alignItems="space-between" onClick={() => setOpen(true)}>
        <Grid item xs={11}>
          <h1 className={styles.title}>{translateCheckout('payment_method')}</h1>
        </Grid>
        <Grid item xs={1} style={{ position: 'relative' }}>
          <IconButton style={{ padding: 0, position: 'absolute', top: 0, right: 0 }}>
            <ArrowForwardIos style={{ width: '14px', height: '14px', color: '#00000061' }} />
          </IconButton>
        </Grid>
      </Grid>
      {selectedPaymentMethod && (
        <Grid container alignItems="space-between">
          <Grid item xs={10}>
            <h6 className={styles.fw500}>{selectedPaymentName}</h6>
            {selectedPaymentSubTitle?.length > 0 && (
              <div className={styles.subTitle}>{selectedPaymentSubTitle}</div>
            )}
          </Grid>
          <Grid item xs={2} style={{ position: 'relative' }}>
            {selectedPaymentMethod?.svgIcons?.map((svgIconURL) => (
              <ImageFallback
                key={svgIconURL}
                src={svgIconURL}
                alt={selectedPaymentName}
                width="40px"
                height="36px"
              />
            ))}
          </Grid>
        </Grid>
      )}
      <PaymentMethodsTab
        openTab={open}
        setOpenTab={setOpen}
        translateCheckout={translateCheckout}
        paymentMethods={paymentMethods}
        selectedVal={selectedVal}
        handleChange={handleChange}
        locale={locale}
      />
    </>
  );
};

export default PaymentMethodMobile;
